export default {
  en: {
    '加载中……': 'Loading…',
    '登录身份已过期，请重新登录！': 'Your session has expired. Please log in again!',
    '登录身份已过期,请重新登录 !': 'Your session has expired. Please log in again!',
    '服务器繁忙': 'Server is busy',
    '网络连接失败，请稍后重试': 'Network connection failed. Please try again later',
    '后端接口连接异常': 'Unable to connect to the server',
    '系统接口请求超时': 'System request timed out',
    '系统接口': 'System API ',
    '异常': ' error',
    '操作成功，数据已重新同步': 'Action completed. Data resynced',
    '操作未完成，请稍后重试': 'Action not completed. Please try again later',
    '策略操作失败，请稍后重试': 'Strategy action failed. Please try again later',
    '策略创建失败': 'Strategy creation failed',
    '策略创建失败，请稍后重试': 'Strategy creation failed. Please try again later',
    '策略可能已删除，或不属于当前交易所。': 'The strategy may have been deleted or may not belong to the current exchange.',
    '策略数据读取失败，请稍后重试': 'Failed to load strategy data. Please try again later',
    '策略详情打开失败': 'Failed to open strategy details',
    '策略重启失败，请稍后重试': 'Failed to restart the strategy. Please try again later',
    '未找到该策略': 'Strategy not found',
    '正在定位当前策略': 'Locating the current strategy',
    '正在读取策略详情…': 'Loading strategy details…',
    '返回机器人': 'Back to bots',
    '该策略暂时无法进入详情': 'Strategy details are temporarily unavailable',
    '当前没有可操作的交易所机器人': 'No exchange bot is available for this action',
    '当前没有可添加策略的交易所': 'No exchange is available for adding a strategy',
    '当前没有可以启动的机器人': 'No bot is available to start',
    '机器人页面尚未加载策略可用名额，暂不能创建策略': 'Strategy quota has not loaded on the Bots page, so a strategy cannot be created yet',
    '机器人操作失败，请稍后重试': 'Bot action failed. Please try again later',
    '机器人关闭失败，请稍后重试': 'Failed to turn off the bot. Please try again later',
    '机器人名称保存失败': 'Failed to save bot name',
    '机器人已关闭，全部运行中的策略已暂停': 'Bot turned off. All active strategies are paused',
    '机器人状态读取失败': 'Failed to load bot status',
    '交易所状态读取失败': 'Failed to load exchange status',
    '未找到验证码接收账号': 'Verification-code receiving account not found',
    '验证码已发送到绑定账号': 'Verification code sent to the bound account',
    '修改最大持仓并重启策略失败': 'Failed to update the maximum position and restart the strategy',
    '最大持仓修改成功，策略已重新启动': 'Maximum position updated and the strategy restarted',
    '充值订单创建失败': 'Failed to create deposit order',
    '充值订单创建失败，请稍后重试': 'Failed to create deposit order. Please try again later',
    '充值订单已创建，二维码加载失败，请复制地址完成充值': 'Deposit order created, but the QR code failed to load. Copy the address to complete the deposit',
    '充值订单已创建，请按订单金额完成转账': 'Deposit order created. Transfer the exact order amount',
    '点卡购买失败': 'Point purchase failed',
    '提现申请失败': 'Withdrawal request failed',
    '账户划转失败': 'Account transfer failed',
    '暂无交易所': 'No exchanges',
    '机器人已关闭': 'Bot turned off',
    '机器人已启动': 'Bot started',
    '关闭失败': 'failed to turn off',
    '启动失败': 'failed to start',
    '机器人关闭失败': 'failed to turn off the bot',
    '机器人启动失败': 'failed to start the bot',
    '尚未绑定交易所 API': 'does not have a bound exchange API',
    '策略数据已同步': 'strategy data synced',
    '机器人状态尚未加载': 'bot status has not loaded',
    '暂不支持创建': 'does not currently support creating',
    '暂不支持创建该策略': 'This strategy cannot currently be created',
    '机器人状态尚未加载，暂不能添加策略': 'The bot status has not loaded, so a strategy cannot be added yet',
    '机器人后，将停止对该交易所策略的监控及运行': 'bot will stop monitoring and running strategies on this exchange',
    '创建成功，策略列表已重新同步': 'created successfully. Strategy list resynced',
    '已创建；': 'created; ',
    '策略开始运行': 'strategies started',
    '确定关闭': 'Confirm turn off',
    '正在关闭': 'Turning off…',
    '机器人已自动暂停': 'Bot paused automatically',
    '已达到最大持仓': 'Maximum position reached',
    '本策略因达到最大持仓而暂停运行，请修改最大持仓后重启策略。': 'This strategy was paused after reaching the maximum position. Update the maximum position and restart it.',
    '新的最大持仓': 'New maximum position',
    '无限': 'Unlimited',
    '正在重启': 'Restarting…',
    '确认修改并重启': 'Confirm update and restart',
    'UPlus 不会对您的任何交易行为承担担保、赔偿等责任。点击确认代表同意本条款。': 'UPlus does not guarantee or compensate for any of your trading activity. By confirming, you agree to these terms.',
    'UPlus智能合约交易风险提示': 'UPlus Smart Contract Trading Risk Notice',
    '关闭风险提示': 'Close risk notice',
    '使用智能合约交易是复杂且有风险的。 您在交易合约时可能会实现大幅收益或损失， 因此在开始交易前请做好充分准备。 小幅价格波动也可能对您的交易产生很大的影响。': 'Smart contract trading is complex and risky. Contract trading may result in substantial gains or losses, so prepare carefully before starting. Even small price movements can have a significant impact on your trades.',
    '极端情况可能会出现止损失效或爆仓情况，比如自己动资金/订单、交易所卡顿、拔网线、 极端行情（黑天鹅）。': 'In extreme situations, stop loss may fail or liquidation may occur, for example after manually moving funds or orders, exchange delays, network disconnection, or extreme black-swan markets.',
    'UPlus对您的任何交易概不负责，包括但不限于担保或赔偿。点击“确认”即表示您同意这些条款。': 'UPlus is not responsible for your trading activity, including guarantees or compensation. Clicking “Confirm” means you agree to these terms.',
    '我已阅读和了解相关协定，并已知晓风险': 'I have read and understood the agreement and acknowledge the risks',
    '点击查看《UPlus智能量化交易协议》': 'View the UPlus Smart Quantitative Trading Agreement',
    '同意UPlus智能量化交易协议': 'Agree to the UPlus Smart Quantitative Trading Agreement',
    '进入交易': 'Enter trading',
    '暂不交易，离开': 'Not now, leave',
    '充值': 'Deposit',
    '确认充值': 'Confirm deposit',
    '充值地址二维码': 'Deposit address QR code',
    '充值地址加载失败': 'Failed to load deposit address',
    '充值订单生成后，请严格按照订单金额和对应公链完成转账。': 'After the deposit order is created, transfer the exact order amount on the specified network.',
    '充值方式加载失败': 'Failed to load deposit methods',
    '充值金额（USDT）': 'Deposit amount (USDT)',
    '二维码加载失败': 'Failed to load QR code',
    '二维码加载中': 'Loading QR code',
    '复制失败，请手动复制充值地址': 'Copy failed. Please copy the deposit address manually',
    '请输入充值金额': 'Enter the deposit amount',
    '请选择充值方式': 'Select a deposit method',
    '正在生成订单…': 'Creating order…',
    '确定退出': 'Confirm log out',
    '确定要退出当前账号吗？': 'Log out of the current account?',
    '退出后需要重新登录，才能继续查看和管理机器人及策略。': 'You will need to log in again to continue viewing and managing bots and strategies.'
  },
  ko: {
    '加载中……': '로딩 중…',
    '登录身份已过期，请重新登录！': '로그인 세션이 만료되었습니다. 다시 로그인하세요!',
    '登录身份已过期,请重新登录 !': '로그인 세션이 만료되었습니다. 다시 로그인하세요!',
    '服务器繁忙': '서버가 혼잡합니다',
    '网络连接失败，请稍后重试': '네트워크 연결에 실패했습니다. 잠시 후 다시 시도하세요',
    '后端接口连接异常': '서버에 연결할 수 없습니다',
    '系统接口请求超时': '시스템 요청 시간이 초과되었습니다',
    '系统接口': '시스템 API ',
    '异常': ' 오류',
    '操作成功，数据已重新同步': '작업이 완료되어 데이터가 다시 동기화되었습니다',
    '操作未完成，请稍后重试': '작업이 완료되지 않았습니다. 잠시 후 다시 시도하세요',
    '策略操作失败，请稍后重试': '전략 작업에 실패했습니다. 잠시 후 다시 시도하세요',
    '策略创建失败': '전략 생성 실패',
    '策略创建失败，请稍后重试': '전략 생성에 실패했습니다. 잠시 후 다시 시도하세요',
    '策略可能已删除，或不属于当前交易所。': '전략이 삭제되었거나 현재 거래소에 속하지 않을 수 있습니다.',
    '策略数据读取失败，请稍后重试': '전략 데이터를 불러오지 못했습니다. 잠시 후 다시 시도하세요',
    '策略详情打开失败': '전략 상세를 열지 못했습니다',
    '策略重启失败，请稍后重试': '전략 재시작에 실패했습니다. 잠시 후 다시 시도하세요',
    '未找到该策略': '전략을 찾을 수 없습니다',
    '正在定位当前策略': '현재 전략을 찾는 중',
    '正在读取策略详情…': '전략 상세 로딩 중…',
    '返回机器人': '봇으로 돌아가기',
    '该策略暂时无法进入详情': '전략 상세를 일시적으로 열 수 없습니다',
    '当前没有可操作的交易所机器人': '작업 가능한 거래소 봇이 없습니다',
    '当前没有可添加策略的交易所': '전략을 추가할 수 있는 거래소가 없습니다',
    '当前没有可以启动的机器人': '시작할 수 있는 봇이 없습니다',
    '机器人页面尚未加载策略可用名额，暂不能创建策略': '봇 페이지의 전략 할당량이 아직 로드되지 않아 전략을 생성할 수 없습니다',
    '机器人操作失败，请稍后重试': '봇 작업에 실패했습니다. 잠시 후 다시 시도하세요',
    '机器人关闭失败，请稍后重试': '봇을 끄지 못했습니다. 잠시 후 다시 시도하세요',
    '机器人名称保存失败': '봇 이름 저장 실패',
    '机器人已关闭，全部运行中的策略已暂停': '봇이 꺼져 실행 중이던 모든 전략이 일시정지되었습니다',
    '机器人状态读取失败': '봇 상태를 불러오지 못했습니다',
    '交易所状态读取失败': '거래소 상태를 불러오지 못했습니다',
    '未找到验证码接收账号': '인증 코드 수신 계정을 찾을 수 없습니다',
    '验证码已发送到绑定账号': '인증 코드가 연결된 계정으로 전송되었습니다',
    '修改最大持仓并重启策略失败': '최대 포지션 수정 및 전략 재시작 실패',
    '最大持仓修改成功，策略已重新启动': '최대 포지션이 수정되어 전략이 다시 시작되었습니다',
    '充值订单创建失败': '충전 주문 생성 실패',
    '充值订单创建失败，请稍后重试': '충전 주문 생성에 실패했습니다. 잠시 후 다시 시도하세요',
    '充值订单已创建，二维码加载失败，请复制地址完成充值': '충전 주문은 생성되었지만 QR 코드를 불러오지 못했습니다. 주소를 복사해 충전을 완료하세요',
    '充值订单已创建，请按订单金额完成转账': '충전 주문이 생성되었습니다. 주문 금액과 동일하게 이체하세요',
    '点卡购买失败': '포인트 구매 실패',
    '提现申请失败': '출금 신청 실패',
    '账户划转失败': '계정 이체 실패',
    '暂无交易所': '거래소 없음',
    '机器人已关闭': '봇 꺼짐',
    '机器人已启动': '봇 시작됨',
    '关闭失败': '끄기 실패',
    '启动失败': '시작 실패',
    '机器人关闭失败': '봇 끄기 실패',
    '机器人启动失败': '봇 시작 실패',
    '尚未绑定交易所 API': '거래소 API가 연결되지 않음',
    '策略数据已同步': '전략 데이터 동기화됨',
    '机器人状态尚未加载': '봇 상태가 아직 로드되지 않음',
    '暂不支持创建': '현재 생성을 지원하지 않음',
    '暂不支持创建该策略': '현재 이 전략을 생성할 수 없습니다',
    '机器人状态尚未加载，暂不能添加策略': '봇 상태가 아직 로드되지 않아 전략을 추가할 수 없습니다',
    '机器人后，将停止对该交易所策略的监控及运行': '봇을 끄면 이 거래소 전략의 모니터링과 실행이 중지됩니다',
    '创建成功，策略列表已重新同步': '생성되어 전략 목록이 다시 동기화됨',
    '已创建；': '생성됨; ',
    '策略开始运行': '개 전략 실행 시작',
    '确定关闭': '끄기 확인',
    '正在关闭': '끄는 중…',
    '机器人已自动暂停': '봇이 자동으로 일시정지되었습니다',
    '已达到最大持仓': '최대 포지션 도달',
    '本策略因达到最大持仓而暂停运行，请修改最大持仓后重启策略。': '최대 포지션에 도달해 전략이 일시정지되었습니다. 최대 포지션을 수정한 뒤 전략을 재시작하세요.',
    '新的最大持仓': '새 최대 포지션',
    '无限': '무제한',
    '正在重启': '재시작 중…',
    '确认修改并重启': '수정 후 재시작 확인',
    'UPlus 不会对您的任何交易行为承担担保、赔偿等责任。点击确认代表同意本条款。': 'UPlus는 사용자의 거래 행위에 대해 보증 또는 배상 책임을 지지 않습니다. 확인을 누르면 본 약관에 동의하는 것입니다.',
    'UPlus智能合约交易风险提示': 'UPlus 스마트 계약 거래 위험 안내',
    '关闭风险提示': '위험 안내 닫기',
    '使用智能合约交易是复杂且有风险的。 您在交易合约时可能会实现大幅收益或损失， 因此在开始交易前请做好充分准备。 小幅价格波动也可能对您的交易产生很大的影响。': '스마트 계약 거래는 복잡하고 위험합니다. 큰 수익 또는 손실이 발생할 수 있으므로 시작 전에 충분히 준비하세요. 작은 가격 변동도 거래에 큰 영향을 줄 수 있습니다.',
    '极端情况可能会出现止损失效或爆仓情况，比如自己动资金/订单、交易所卡顿、拔网线、 极端行情（黑天鹅）。': '직접 자금이나 주문을 이동하거나 거래소 지연, 네트워크 단절, 극단적 시장 상황이 발생하면 손절이 실패하거나 강제 청산될 수 있습니다.',
    'UPlus对您的任何交易概不负责，包括但不限于担保或赔偿。点击“确认”即表示您同意这些条款。': 'UPlus는 보증 또는 배상을 포함해 사용자의 거래에 책임을 지지 않습니다. “확인”을 누르면 본 약관에 동의하는 것입니다.',
    '我已阅读和了解相关协定，并已知晓风险': '관련 계약을 읽고 이해했으며 위험을 인지했습니다',
    '点击查看《UPlus智能量化交易协议》': 'UPlus 스마트 양적 거래 계약 보기',
    '同意UPlus智能量化交易协议': 'UPlus 스마트 양적 거래 계약 동의',
    '进入交易': '거래 시작',
    '暂不交易，离开': '지금은 거래하지 않고 나가기',
    '充值': '충전',
    '确认充值': '충전 확인',
    '充值地址二维码': '충전 주소 QR 코드',
    '充值地址加载失败': '충전 주소 로딩 실패',
    '充值订单生成后，请严格按照订单金额和对应公链完成转账。': '충전 주문 생성 후 주문 금액과 지정 네트워크를 정확히 확인해 이체하세요.',
    '充值方式加载失败': '충전 방법 로딩 실패',
    '充值金额（USDT）': '충전 금액 (USDT)',
    '二维码加载失败': 'QR 코드 로딩 실패',
    '二维码加载中': 'QR 코드 로딩 중',
    '复制失败，请手动复制充值地址': '복사에 실패했습니다. 충전 주소를 직접 복사하세요',
    '请输入充值金额': '충전 금액을 입력하세요',
    '请选择充值方式': '충전 방법을 선택하세요',
    '正在生成订单…': '주문 생성 중…',
    '确定退出': '로그아웃 확인',
    '确定要退出当前账号吗？': '현재 계정에서 로그아웃할까요?',
    '退出后需要重新登录，才能继续查看和管理机器人及策略。': '봇과 전략을 계속 확인하고 관리하려면 다시 로그인해야 합니다.'
  }
}
